/* eslint-disable */
export enum ProgressTypes {
  consumed = "consumed",
  remaining = "remaining",
}

export enum BarTypes {
  primary = "primary",
  pen = "pen",
}

export enum CircleTypes {
  primary = "primary",
  feed = "feed",
}
/* eslint-enable */

export interface Progress_Props {
  total?: number
  progressed?: number
  animation?: boolean
  labels?: {
    header?: string
    unit?: JSX.Element
    noDataDisclaimer?: string,
  }
  extension?: {
    hasExtension?: boolean
  }
}